import { render } from "./AlertView.vue?vue&type=template&id=297b2eb4"
import script from "./AlertScript.vue?vue&type=script&lang=js&external"
export * from "./AlertScript.vue?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__